<template lang="pug">
v-container(ma-0 pa-0 fluid style="margin-top: 100px !important;")
  v-layout.highschoolvote-and-video(text-xs-left='', wrap='' align-item-center justify-center)
    v-flex.section-highschoolvote(xs10 md4)
      h1.title-all 學生會選舉：<br>
                  | 每一個聲音都值得被聽見
      br
      span.content-all(v-html="highschoolVoteText")
    v-flex.section-highschoolvote-video(xs12 offset-md0 md6)
      v-layout(align-center justify-center fill-height)
        v-flex(xs12)
          iframe(:src='video_url', 
                frameborder='0', allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture', 
                allowfullscreen='')

</template>

<script>
export default {
  data: () => ({
    video_url: "https://www.youtube.com/embed/L27yYuciWjo",
    highschoolVoteText:
      "除了舉辦大型校級活動之外，你知道學生會也是守護學生權益的第一線嗎？<br><br>學生會長能夠參與不同校級會議，學生會能夠蒐集所有同學的意見，讓師長們聽到同學的聲音，也能從學生的角度出發，提供學生方覺得最合適的建議。<br><br>當我們認真來審視每個會長候選人的政見以及執行能力，這會是參與公共事務的第一步，進而策進學生會繼續在學生權益的領域中努力，形成一個正向的循環。<br><br>走進投票所那刻，你投的不只是學生會長。<br><br>這一刻，更是對學校、對社會宣示，身為學生的我們，我們願意參與公眾事務，在學校的各種決策上，學生的聲音不應缺席！<br><br>"
  }),
  mounted() {}
};
</script>

<style lang="scss" scoped>
iframe {
  width: 100%;
  height: 500px;
  margin-left: 50px;
  @media screen and (max-width: 959px) {
    margin-left: 0px;
  }
}
</style>
